module.exports = __webpack_public_path__ + "media/snowswipeone.336ac70e.mp3";